/* eslint-disable react-refresh/only-export-components -- Context modules intentionally export provider + hooks. */
import React, { createContext, useContext, useState } from 'react';

interface UploadQueueWidgetContextType {
  isOpen: boolean;
  openWidget: () => void;
  closeWidget: () => void;
  toggleWidget: () => void;
}

const UploadQueueWidgetContext = createContext<
  UploadQueueWidgetContextType | undefined
>(undefined);

export const useUploadQueueWidget = () => {
  const context = useContext(UploadQueueWidgetContext);
  if (!context) {
    throw new Error(
      'useUploadQueueWidget must be used within UploadQueueWidgetProvider'
    );
  }
  return context;
};

interface UploadQueueWidgetProviderProps {
  children: React.ReactNode;
}

export const UploadQueueWidgetProvider: React.FC<
  UploadQueueWidgetProviderProps
> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openWidget = () => setIsOpen(true);
  const closeWidget = () => setIsOpen(false);
  const toggleWidget = () => setIsOpen(!isOpen);

  return (
    <UploadQueueWidgetContext.Provider
      value={{
        isOpen,
        openWidget,
        closeWidget,
        toggleWidget,
      }}
    >
      {children}
    </UploadQueueWidgetContext.Provider>
  );
};
